import {useApi} from "../Api";
import {
    ExceptionListAncillaryExceptionAssociation, ExceptionListAncillaryExceptionAssociationDelete,
    ExceptionListAncillaryExceptions,
    FormSearchExceptionListAncillaryExceptionModel
} from "../types/exceptionListAncillaryExceptionModel";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";

export const useExceptionListAncillaryExceptionRepository = () => {
    const {GET, POST, DELETE} = useApi();

    const PATH = "/pricing/exception-list-exception";

    function postExceptionListAncillaryExceptionAll(exceptionListAncillaryExceptions: ExceptionListAncillaryExceptionAssociation[]): Promise<ExceptionListAncillaryExceptionAssociation[]> {
        return POST(`${PATH}/full`, exceptionListAncillaryExceptions);
    }

    function getExceptionListAncillaryExceptionsPaged(filters: FormSearchExceptionListAncillaryExceptionModel): Promise<PagedResponse<ExceptionListAncillaryExceptions>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function deleteExceptionListAncillaryException(exceptionListAncillaryException: ExceptionListAncillaryExceptionAssociation): Promise<ExceptionListAncillaryExceptionAssociation[]> {
        return DELETE(`${PATH}?exceptionListId=${exceptionListAncillaryException.id.exceptionListId}&ancillaryExceptionId=${exceptionListAncillaryException.id.ancillaryExceptionId}`);
    }

    function getDeleteException(filters: ExceptionListAncillaryExceptionAssociationDelete): Promise<ExceptionListAncillaryExceptionAssociationDelete[]> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/delete-association${queryParams ? query + queryParams : ""}`);
    }


    return {
        postExceptionListAncillaryExceptionAll,
        getExceptionListAncillaryExceptionsPaged,
        deleteExceptionListAncillaryException,
        getDeleteException
    };
};